import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  serverError,
  successAddworkfloww,
} from './../../../../../core/models/messages';
import { CraEsnService } from './../../../../../core/services/cra-esn/cra-esn.service';
import { EsnpermissionService } from './../../../../../core/services/esnpermission/esnpermission.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-workflow-consultant',
  templateUrl: './workflow-consultant.component.html',
  styleUrls: ['./workflow-consultant.component.css'],
})
export class WorkflowConsultantComponent {
  formWorkFlow: FormGroup = this.createWorkFlowForm();
  currentStep: number = 1;
  listrole: Array<{ id: number, name: string }> = []; // Initialisez votre liste ici
  roleConsultant:string="Consultant"

  name = [
    { id: '1', name: 'Consultant' },
    { id: '2', name: 'Responsable' },
    { id: '3', name: 'RH' },
  ];
  state = [
    { id: '1', name: 'Validé' },
    { id: '2', name: 'Rejeté' },
  ];
  list: any
  listroleWithStatic!: Array<{ id: number, name: string }>;

  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private serviceCraEsn: CraEsnService,
    private spinner: NgxSpinnerService,
    private roleservice: EsnpermissionService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.getWorkflowConsultants();
    this.getListrole();
  }

  createFormssubWorkFlows(data?: any, index?: number) {
    return this.formBuilder.group({
      role_id: [data ? data.role_id : null, [this.validateUniqueRole(index || 0)]],
      step: [index ? index + 1 : 1],
    });
  }
  addsubWorkFlows() {
    const sub_workflow_cras = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    sub_workflow_cras.push(this.createFormssubWorkFlows(undefined, sub_workflow_cras.length));
    this.updateRoleValidators()
  }
  
  updateRoleValidators(): void {
    const sub_workflow_cras = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    
    sub_workflow_cras.controls.forEach((formGroup, index) => {
      formGroup.get('role_id')?.setValidators(this.validateUniqueRole(index));
      formGroup.get('role_id')?.updateValueAndValidity();  
    });
  }

  validateUniqueRole(index: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const sub_workflow_cras = this.formWorkFlow?.get('sub_workflow_cras') as FormArray;
      const selectedRoleId = control.value;
        
      let isDuplicate = false;
      sub_workflow_cras?.controls.forEach((formGroup, i) => {
        if (i !== index && formGroup.get('role_id')?.value === selectedRoleId) {
          isDuplicate = true;
        }
      });
  
      return isDuplicate ? { duplicateRole: true } : null;
    };
  }
  createWorkFlowForm(data?: any) {
    return this.formBuilder.group({
      workflow_id: null,
      consultant_ids: [data?.consultant_ids || []],
      type: '2',
      sub_workflow_cras: this.formBuilder.array(
        Array.isArray(data?.sub_workflow_cras) && data?.sub_workflow_cras.length
          ? data.sub_workflow_cras.map((item: any, index: number) =>
              this.createFormssubWorkFlows(item, index)
            )
          : [this.createFormssubWorkFlows(undefined, 0)],
          this.roleValidator()
      ),
    });
  }

  /* create workflow general*/
  createWorkflow() {
    this.spinner.show();
    this.formWorkFlow.value.sub_workflow_cras = this.updateSubWorkflows( this.formWorkFlow.value.sub_workflow_cras)
    this.serviceCraEsn
      .createWorkFlowForm(this.formWorkFlow.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastrService.success(successAddworkfloww);
          this.formWorkFlow.reset();
          this.router.navigate(['/cra/list-workflow']);
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
            } else {
              this.toastrService.error(serverError);
            }
          }
        },
      });
  }
  get subWorkFlowsControls(): AbstractControl<any, any>[] {
    return (this.formWorkFlow.get('sub_workflow_cras') as FormArray)?.controls || [];
  }
  removesubWorkFlows(index: number) {
    const sub_workflow_cras = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    if (sub_workflow_cras.length > 1) {
      sub_workflow_cras.removeAt(index);
    }
    this.updateRoleValidators()
  }
  ResetForm() {
    this.formWorkFlow.get('consultant_ids')?.setValue([]);
    const subWorkflowArray = this.formWorkFlow.get('sub_workflow_cras') as FormArray;
    subWorkflowArray.clear();
    subWorkflowArray.push(this.createFormssubWorkFlows(undefined, 0));
  }

  redirectListWorkflow(){
    this.router.navigateByUrl('/cra/list-workflow');
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  /* list consultant*/
  getWorkflowConsultants() {
    this.spinner.show();
    let esn_name = this.localStorageService.getData('clientConnectedName');
    this.serviceCraEsn
      .getWorkflowConsultants(esn_name)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.list = res.data;
          this.listresponsablesWithDisplayName()
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  listresponsablesWithDisplayName() {
    this.list.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  getListrole() {
    this.roleservice.getlisterolesUpdate().subscribe({
      next: (response) => {
        if (response.data) {
          const roles = response.data.data;          
          this.listrole = roles?.filter((role: { hasUsers: boolean; }) => role.hasUsers === true)
          console.log('this.listrole',this.listrole)
        }
      },
      error: (error) => {
      },
    });
  }

  updateSubWorkflows(subWorkflows: any[]): any[] {
    subWorkflows.unshift({
      role_id: null,
      step: 1,
    });
    subWorkflows = subWorkflows.map((workflow: any, index: number) => ({
      ...workflow,
      step: index + 1,
    }));
    return subWorkflows;
  }

  roleValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const formArray = control as FormArray;
      const roles = formArray.controls.map(group => group.get('role_id')?.value);
      
      const duplicates = roles.filter((role, index) => roles.indexOf(role) !== index);
      const nullRolesCount = roles.filter(role => role === null).length;
      const errors: any = {};
      
      if (duplicates.length > 0) {
        errors['duplicateRole'] = true;
      }
      
      if (nullRolesCount > 0) {
        errors['multipleNullRole'] = true;
      }
  
      return Object.keys(errors).length > 0 ? errors : null;
    };
  }

  disableBtnSave() : boolean{
    return this.formWorkFlow.get('consultant_ids')?.value?.length < 1 || this.disableAddSelect()
  }

  showDisableTooltip() : boolean{
    const duplicateRole = this.formWorkFlow.get('sub_workflow_cras')?.hasError('duplicateRole') ? true : false
    const multipleNullRole = this.formWorkFlow.get('sub_workflow_cras')?.hasError('multipleNullRole') ? true : false
    return !duplicateRole && (this.formWorkFlow.get('consultant_ids')?.value?.length < 1 || multipleNullRole)  
  }

  disableAddSelect() : boolean{
    const subWorkflow = this.formWorkFlow.get('sub_workflow_cras')
    const duplicateRole = subWorkflow?.hasError('duplicateRole') ? true : false
    const multipleNullRole = subWorkflow?.hasError('multipleNullRole') ? true : false
    const hasEmptySelect = subWorkflow?.value?.filter((element: { role_id: any; }) => element.role_id === null)?.length > 1

    return duplicateRole || multipleNullRole || hasEmptySelect
  }
}
